import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'vacancies',
    loadChildren: () => import('./vacancies/vacancies.routes').then(m => m.ROUTES),
  },
  {
    path: '**',
    redirectTo: 'vacancies',
  },
];
